import { parseTime } from '@/utils';
import i18n from '@/lang';

/**
 * Resolve a nested path in an object (e.g., "address.city" or "items[0].name")
 */
export function resolvePathValue(obj: any, path: string, defaultValue: any = ''): any {
	if (!obj || !path) return defaultValue;
	return path
		.split(/[\.\[\]\'\"]/)
		.filter(p => p)
		.reduce((o, p) => (o ? o[p] : defaultValue), obj);
}

/**
 * Get the localized label for a custom field definition
 */
export function getCustomFieldLabel(definition: any, locale?: string): string {
	const currentLocale = locale || i18n.locale;
	if (definition.label && typeof definition.label === 'object') {
		return definition.label[currentLocale] || definition.label.en || definition.path;
	}
	return definition.label || definition.path;
}

/**
 * Format a custom field value based on its type (for display in tables/text)
 */
export function formatCustomFieldValue(value: any, type: string): string {
	if (value === null || value === undefined || value === '') return '-';

	switch (type) {
		case 'BOOLEAN':
			return value ? '✓' : '✗';
		case 'DATE':
			return parseTime(value, '{d}-{m}-{y}');
		case 'CURRENCY': {
			const num = Number(value);
			if (isNaN(num)) return String(value);
			return `€ ${num.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
		}
		case 'INT':
		case 'DECIMAL':
		case 'STRING':
		default:
			return String(value);
	}
}

/**
 * Get the value of a custom field from custom_fields object.
 * Coerces to number for numeric types so AG Grid sorts/filters correctly.
 */
const NUMERIC_TYPES = ['CURRENCY', 'INT', 'DECIMAL'];

export function getCustomFieldValue(customFields: any, path: string, type?: string): any {
	const value = resolvePathValue(customFields, path, '');
	if (!type || !NUMERIC_TYPES.includes(type)) return value;
	const num = Number(value);
	return (value === '' || value == null || isNaN(num)) ? null : num;
}

export function getAgGridFilterType(type: string): string | boolean {
	return NUMERIC_TYPES.includes(type) ? 'agNumberColumnFilter' : true;
}

